import { getRequestCommon } from 'live/lib/utils'

const ASSETS_URL = '/services/plugin-liverig/assets'
const URL = `${ASSETS_URL}/intervention`

export function getReportFromSitop (interventionId: string) {
    return fetch(`${URL}/view/sitop/${interventionId}`, getRequestCommon)
}
